import React, { useEffect } from 'react';
import { Grid, TextField, Typography, Paper, FormControlLabel, Checkbox } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useFormValidation } from './useFormValidation';

/* =======================
   STEP 1 — Datos Generales y Anexos (Corregido para 004)
   ======================= */
function DatosEntrevistadoYAnexos({ state, onChange, onError, solicitud }) {
    const { safeValue, safeError, conError } = useFormValidation(state);
    const esMenor = state?.es_menor_edad?.valor === 'SI';
    const theme = useTheme();

    useEffect(() => {

            // Valor por defecto: si no se ha tocado el campo, asumir "NO"
            if (!state?.es_menor_edad || !state.es_menor_edad.valor) {
                onChange({
                    target: {
                        name: 'es_menor_edad',
                        value: 'NO'
                    }
                });
            }

            if (solicitud?.usuario_registro) {
    
                const usuario = solicitud.usuario_registro;
    
                const nombreCompleto = `
                    ${usuario.primer_nombre || ''} 
                    ${usuario.segundo_nombre || ''} 
                    ${usuario.primer_apellido || ''} 
                    ${usuario.segundo_apellido || ''}
                `.replace(/\s+/g, ' ').trim();
    
                onChange({
                    target: {
                        name: 'nombre_completo',
                        value: nombreCompleto
                    }
                });

                onChange({
                    target: {
                        name: 'nombre_representante',
                        value: nombreCompleto
                    }
                });
    
                onChange({
                    target: {
                        name: 'documento_identidad',
                        value: usuario.identificacion || ''
                    }
                });
    
                onChange({
                    target: {
                        name: 'numero_contacto',
                        value: usuario.celular || usuario.telefono || ''
                    }
                });
            }
        }, [solicitud]);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}` }}>
                    <Typography variant="caption" style={{ textAlign: 'justify', display: 'block' }}>
                        La entrevista es una herramienta para conocer su versión sobre hechos vinculados a violencia basada en género. 
                        Se garantiza privacidad y respeto. La confidencialidad se limitará en caso de riesgo para la vida o abuso de niños/ancianos.
                    </Typography>
                    <Typography variant="caption" style={{ textAlign: 'justify', display: 'block', marginTop: 5 }}>
                        Doy fe que se me ha explicado tanto el alcance como los límites de la entrevista.
                    </Typography>
                </Paper>
            </Grid>

            {/* Datos del Entrevistado - USANDO CLAVES GENERALES */}
            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="Nombre Completo"
                    name="nombre_completo" 
                    value={safeValue('nombre_completo')}
                    onChange={onChange}
                    error={!!safeError('nombre_completo')}
                    helperText={safeError('nombre_completo')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Número de contacto"
                    name="numero_contacto"
                    value={safeValue('numero_contacto')}
                    onChange={onChange}
                    error={conError(safeError('numero_contacto'))}
                    helperText={safeError('numero_contacto')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="No. de documento"
                    name="documento_identidad"
                    value={safeValue('documento_identidad')}
                    onChange={onChange}
                    error={conError(safeError('documento_identidad'))}
                    helperText={safeError('documento_identidad')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Donde fue expedido"
                    name="lugar_expedicion"
                    value={safeValue('lugar_expedicion')}
                    onChange={onChange}
                    error={conError(safeError('lugar_expedicion'))}
                    helperText={safeError('lugar_expedicion')}
                />
            </Grid>

            {/* Control de Edad */}
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={esMenor}
                            onChange={(e) => onChange({
                                target: {
                                    name: 'es_menor_edad',
                                    value: e.target.checked ? 'SI' : 'NO'
                                }
                            })}
                            color="primary"
                        />
                    }
                    label="¿El entrevistado es menor de edad?"
                />
            </Grid>

            {esMenor ? (
                <>
                    {/* ANEXO 1: REPRESENTANTE LEGAL (MENORES) */}
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Padre de Familia de (Él / la) estudiante"
                            name="nombre_representante" 
                            value={safeValue('nombre_representante')}
                            onChange={onChange}
                            error={conError(safeError('nombre_representante'))}
                            helperText={safeError('nombre_representante')}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="CC. Representante"
                            name="cc_representante"
                            value={safeValue('cc_representante')}
                            onChange={onChange}
                            error={conError(safeError('cc_representante'))}
                            helperText={safeError('cc_representante')}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Expedida en"
                            name="expedicion_representante" 
                            value={safeValue('expedicion_representante')}
                            onChange={onChange}
                            error={conError(safeError('expedicion_representante'))}
                            helperText={safeError('expedicion_representante')}
                        />
                    </Grid>
                </>
            ) : (
                <>
                    {/* ANEXO 2: ACOMPAÑANTE (MAYORES) */}
                    <Grid item xs={12} md={8}>
                        <TextField
                            fullWidth
                            label="Nombre de la persona autorizada"
                            name="nombre_autorizado" 
                            value={safeValue('nombre_autorizado')}
                            onChange={onChange}
                            error={conError(safeError('nombre_autorizado'))}
                            helperText={safeError('nombre_autorizado')}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Identificado con CC"
                            name="cc_autorizado" 
                            value={safeValue('cc_autorizado')}
                            onChange={onChange}
                            error={conError(safeError('cc_autorizado'))}
                            helperText={safeError('cc_autorizado')}
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
}

export const Formulario004Steps = [
    {
        label: 'Datos de la Entrevista y Acompañamiento',
        render: (props) => <DatosEntrevistadoYAnexos {...props} />
    }
];